<div class="page-header">
    <h1>{{'newOrganization' | i18n}}</h1>
</div>
<p>{{'newOrganizationDesc' | i18n}}</p>
<app-organization-plans></app-organization-plans>
